import ActionTypes from './actionTypes';

export enum ActionLoginToCheckoutResponses {
  wrongCode = 'wrongCode',
  phoneNumberInvalid = 'phoneNumberInvalid',
  verificationCodeNeeded = 'verificationCodeNeeded',
  phoneNumberNotMatching = 'phoneNumberNotMatching',
  alreadyVerified = 'alreadyVerified',
  expiredCode = 'expiredCode',
  exceededVerificationAttempts = 'exceededVerificationAttempts',
}

export enum ActionCongratulationResponses {
  ILLEGAL_ARGUMENT = 'ILLEGAL_ARGUMENT',
}

const APIResponses = {
    [ActionTypes.ActionLoginToCheckout]: ActionLoginToCheckoutResponses
};

export default APIResponses
